import type { TaskDTO } from 'src/types/dto/task.dto';

import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints } from 'src/utils/axios';

import { DEFAULT_SWR_OPTIONS } from 'src/config/swr';

const SWR_OPTIONS = {
  ...DEFAULT_SWR_OPTIONS,
  revalidateOnFocus: false,
};

type TaskFilterOptions = {
  titles: string[];
  projects: { id: number; name: string; orderRef: string }[];
  activities: { id: number; name: string }[];
  asignees: { id: number; name: string }[];
  creators: { id: number; name: string }[];
  dueDates: Date[];
  followUpDates: Date[];
};

export function useGetTask(id: number | string) {
  const { data, isLoading, error, isValidating, mutate } = useSWR<TaskDTO>(
    endpoints.tasks.details(id),
    fetcher,
    SWR_OPTIONS
  );

  const memoizedValue = useMemo(
    () => ({
      task: data,
      taskLoading: isLoading,
      taskError: error,
      taskValidating: isValidating,
      mutateTask: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}


export function useGetTaskFilterOptions() {
  const { data, isLoading, error, isValidating, mutate } = useSWR<TaskFilterOptions>(
    endpoints.tasks.filterOptions,
    fetcher,
    { ...SWR_OPTIONS, keepPreviousData: true }
  );

  const memoizedValue = useMemo(
    () => ({
      filterOptions: data,
      filterOptionsLoading: isLoading,
      filterOptionsError: error,
      filterOptionsValidating: isValidating,
      mutateFilterOptions: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
